import { handleClientError, get } from '../lib'
export interface StrategyPayload {
  form: boolean
  sso: { id: string; name: string }[]
  allow_lost_password: boolean
  allow_register_users: boolean
  aupPolicy: string
}
export const getAuthorizationStrategy = async (): Promise<StrategyPayload> => {
  return get<StrategyPayload>({
    path: '/auth/authorization/strategy'
  })
}
